export default __webpack_public_path__ + "static/media/checkmark.08e03e7b.svg";